import React from 'react'
import { graphql, usePaginationFragment } from 'react-relay'
import { Trans } from '@lingui/react/macro'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { EventCard } from '@newComponents/Event/EventCard'

import { PresentationEvents_presentation$key } from './__generated__/PresentationEvents_presentation.graphql'

type PresentationEventsProps = {
  presentation: PresentationEvents_presentation$key
}

const PresentationEvents = (props: PresentationEventsProps) => {
  const { data } = usePaginationFragment(
    graphql`
      fragment PresentationEvents_presentation on Presentation
      @refetchable(queryName: "PresentationEventsPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 2 }
        cursor: { type: "Cursor" }
      ) {
        events(first: $count, after: $cursor)
          @connection(key: "PresentationEvents_presentation_events") {
          edges {
            node {
              id
              ...EventCardNew_event
            }

            cursor
          }
        }
      }
    `,
    props.presentation
  )

  if (data.events.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$5'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$color'><Trans>Presented at these Events</Trans></Strong>
        <Separator borderColor='$borderColor' />
      </XStack>

      <XStack flexWrap='wrap' gap='$4'>
        {data.events.edges.map((edge) => (
          <YStack key={edge.cursor} flexGrow={1} flexBasis={240} $sm={{ flexBasis: '100%' }} maxWidth='100%'>
            <EventCard event={edge.node} flex={1} />
          </YStack>
        ))}
      </XStack>
    </YStack>
  )
}

export default PresentationEvents
